import { render, staticRenderFns } from "./VoyageToOurLifeHeritage2022.vue?vue&type=template&id=1550c9b1&scoped=true"
import script from "./VoyageToOurLifeHeritage2022.vue?vue&type=script&lang=js"
export * from "./VoyageToOurLifeHeritage2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1550c9b1",
  null
  
)

export default component.exports